import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeographyMasterService } from '../geography_master.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'branch-master',
    templateUrl: './branch_master.component.html',
    styleUrls: ['../geography_master.css']
})
export class branchMaster implements OnInit {

    collectionDetails = [];
    searchDataPafing = [];

    indexStart = 0;
    indexEnd = 10;
    pageSize = 5;
    pageNo = 1;
    totalPage = [1];

    searchInput = '';
    IsRecordUpdated = false;

    branchName = '';
    code = '';
    ButtonValue = 'Save';
    viewMode = false;
    CreatedBy = '';
    IsDeleting = false;
    DeletedIndex = '';
    createdDate = '';
    country: any;
    cityId = '';
    city = [];
    area = [];
    branchId = '';
    addressLine1 = '';
    addressLine2 = '';

    cityArray = [];

    dropdownSettings = {};
    selectedItems = [];
    dropdownList = [];
    branchAreaMapping = [];


    constructor(private router: Router,
        public toastr: ToastsManager, vcr: ViewContainerRef,
        private PaymentService: GeographyMasterService,
        private fb: FormBuilder) {

        this.toastr.setRootViewContainerRef(vcr);
        this.PaymentService.GetCityList('')
            .subscribe(departmentListData => {
                this.cityArray = departmentListData;
            });


        this.PaymentService.GetBranchList('')
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }


    ngOnInit() {
        // this.dropdownList = [
        //     { "id": 1, "itemName": "India" },
        //     { "id": 2, "itemName": "Singapore" },
        //     { "id": 3, "itemName": "Australia" },
        //     { "id": 4, "itemName": "Canada" },
        //     { "id": 5, "itemName": "South Korea" },
        //     { "id": 6, "itemName": "Germany" },
        //     { "id": 7, "itemName": "France" },
        //     { "id": 8, "itemName": "Russia" },
        //     { "id": 9, "itemName": "Italy" },
        //     { "id": 10, "itemName": "Sweden" }
        // ];
        // this.selectedItems = [
        //     { "id": 2, "itemName": "Singapore" },
        //     { "id": 3, "itemName": "Australia" },
        //     { "id": 4, "itemName": "Canada" },
        //     { "id": 5, "itemName": "South Korea" }
        // ];
        this.dropdownSettings = {
            singleSelection: false,
            text: "Select Areas",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: "myclass custom-class"
        };
        this.cityChange(null);
    }

    pagingAgent(data) {
        this.pageNo = data;
        this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
        this.indexEnd = (this.pageNo) * this.pageSize;
    }

    changeItemsPerPage(data) {
        if (this.collectionDetails.length > 0) {
            this.totalPage = [1]
            let j = 1;
            for (var i = 0; i < this.collectionDetails.length; i++) {
                i = i + this.pageSize;
                j = j + 1;
                this.totalPage.push(j);
            }
        }
        else {
            this.totalPage = [];
        }
        this.pageSize = data;
        this.indexStart = 0;
        this.indexEnd = this.pageSize;
    }

    searchInputFunction() {
        this.PaymentService.GetBranchList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    UpdateRecordsPopulate(obj) {
        this.viewMode = false;
        this.ButtonValue = 'Update';

        this.branchName = obj["branchName"];
        this.code = obj["branchCode"];
        this.cityId = obj["cityId"];
        this.createdDate = obj['createdDate'];
        this.city = obj['city'];
        this.area = obj['area'];
        this.branchId = obj['id'];
        this.addressLine1 = obj['addressLine1'];
        this.addressLine2 = obj['addressLine2'];
        this.branchAreaMapping = obj["branchAreaMapping"];
        this.selectedItems = [];

        for (var i = 0; i < obj["area"].length; i++) {
            for (var j = 0; j < this.dropdownList.length; j++) {
                if (obj["area"][i] == this.dropdownList[j]["id"]) {
                    this.selectedItems.push({ "id": this.dropdownList[j]["id"], "itemName": this.dropdownList[j]["itemName"] });
                }
            }
        }
    }

    ViewRecordsPopulate(obj) {
        this.viewMode = true;
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Save';

        this.branchName = obj["branchName"];
        this.code = obj["branchCode"];
        this.cityId = obj["cityId"];
        this.createdDate = obj['createdDate'];
        this.city = obj['city'];
        this.branchId = obj['id'];
        this.addressLine1 = obj['addressLine1'];
        this.addressLine2 = obj['addressLine2'];

        this.selectedItems = [];
        for (var i = 0; i < obj["area"].length; i++) {
            for (var j = 0; j < this.dropdownList.length; j++) {
                if (obj["area"][i] == this.dropdownList[j]["id"]) {
                    this.selectedItems.push({ "id": this.dropdownList[j]["id"], "itemName": this.dropdownList[j]["itemName"] });
                }
            }
        }
    }

    reset() {
        this.viewMode = false;
        this.branchName = '';
        this.code = '';
        this.ButtonValue = 'Save';
        this.cityId = '';
        this.city = [];
        this.branchId = '';
        this.addressLine1 = '';
        this.addressLine2 = '';
        this.selectedItems = [];
    }

    memberFormSubmit() {
        if (this.branchId != '') {

            let selectedAreaIds = [];
            let selectedAreaNames = [];
            for (var i = 0; i < this.selectedItems.length; i++) {
                selectedAreaIds.push(this.selectedItems[i]["id"]);
                selectedAreaNames.push(this.selectedItems[i]["itemName"]);
            }
            let data = {
                "addressLine1": this.addressLine1,
                "addressLine2": this.addressLine2,             
                "area": selectedAreaIds,
                "areaNames": selectedAreaNames,
                "branchAreaMapping": this.branchAreaMapping,
                'branchCode': this.code,
                'branchName': this.branchName,
                "city": this.city,
                "cityId": this.cityId,
                "createdBy": this.createdDate,
                "createdDate": this.createdDate,
                "id": this.branchId,
                "isDeleted":false,
                "lastModifiedBy": "",
                "lastModifiedDate": null
            }
            this.PaymentService.EditBranch(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record updated succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("Area Name and Code already exists.");
                    }
                });
        }
        else {
            let selectedAreaIds = [];
            for (var i = 0; i < this.selectedItems.length; i++) {
                selectedAreaIds.push(this.selectedItems[i]["id"]);
            }
            let data = {
                "addressLine1": this.addressLine1,
                "addressLine2": this.addressLine2,
                "description": this.branchName,
                "area": selectedAreaIds,
                "branchCode": this.code,
                "branchName": this.branchName,
                "cityId": this.cityId,
                "loggedInUserId": ''
            }
            this.PaymentService.CreateBranch(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record Added succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("City Name and Code already exists.");
                    }
                });
        }
    }

    codegen() {
    }

    deleteProdutConfirm(id, i) {
        this.cityId = id;
        this.IsDeleting = true;
        this.DeletedIndex = i;
    }
    delete() {
        let data = {
            "id": this.cityId,
            "trackingState": this.DeletedIndex
        }
        // this.PaymentService.DeleteProductGroup(data)
        //     .subscribe(departmentListData => {

        //     });
    }
    deleteCancel() {
        this.IsDeleting = false;
        this.cityId = '';
        this.DeletedIndex = '';
    }

    LoadGrid() {
        this.PaymentService.GetAreaList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }
    cityChange(obj) {
        console.log(this.selectedItems);
        this.PaymentService.GetAreaList('')
            .subscribe(departmentListData => {

                for (let i = 0; i < departmentListData.length; i++) {
                    this.dropdownList.push({ "id": departmentListData[i]["id"], "itemName": departmentListData[i]["description"] });
                }
                //this.dropdownList = departmentListData;
            });
    }
    // Multiselect dropdown event start
    onItemSelect(item: any) {
        console.log(item);
        // console.log(this.selectedItems2);
    }
    OnItemDeSelect(item: any) {
        console.log(item);
        //console.log(this.selectedItems2);
    }
    onSelectAll(items: any) {
        console.log(items);
    }
    onDeSelectAll(items: any) {
        console.log(items);
    }
    //Multiselect dropdown event end
}



// WEBPACK FOOTER //
// ./src/app/system_setting/geography_master/branch_master/branch_master.component.ts